/* (#12) i18n dictionaries — minimal in-house variant.  No external
   deps, lookup is O(1), missing keys fall back to the Russian source. */

export type Locale = 'ru' | 'en';

type Dict = Record<string, string>;

const ru: Dict = {
  // Tree
  'tree.search.placeholder': 'Найти…',
  'tree.search.title': 'Поиск по дереву — модули, композиции, комнаты. Cmd/Ctrl+F фокусирует.',
  'tree.wall_tier.label': 'Низ навесов, мм:',
  'tree.wall_tier.title': 'На какой высоте от пола встают навесные (верхние) шкафы, когда перетаскиваешь модуль-навес в комнату. По умолчанию 1400 мм.',
  'tree.mode.byRoom': 'По комнатам',
  'tree.mode.byType': 'По типам',
  'tree.section.rooms': 'Комнаты',
  'tree.section.compositions': 'Композиции',
  'tree.section.apartment': 'Квартира',
  'tree.section.furniture': 'Мебель',
  'tree.section.parts': 'Детали',
  'tree.section.hardware': 'Фурнитура',

  // Tour
  'tour.next': 'Дальше →',
  'tour.skip': 'Пропустить',
  'tour.done': 'Готово',

  // Estimate
  'estimate.row.editTitle': 'Клик: править ₽',
  'estimate.row.overriddenTitle': 'Цена переопределена · клик чтобы сменить',
  'estimate.row.clearTitle': 'Сбросить переопределение',
  'estimate.title': 'Смета',
  'estimate.total': 'Итого',
  'estimate.materials': 'Материалы',
  'estimate.hardware': 'Фурнитура',
  'estimate.operations': 'Операции',
  'estimate.viewDetailed': 'Подробно',
  'estimate.viewSummary': 'Сводно',

  // TopBar
  'topbar.export': 'Экспорт проекта (.holzcom)',
  'topbar.import': 'Импорт .holzcom',
  'topbar.commands': 'Команды (⌘K)',
  'topbar.theme.dark': 'Тёмная тема',
  'topbar.theme.light': 'Светлая тема',
  'topbar.tour.show': 'Показать обучение',
  'topbar.tour.hide': 'Скрыть обучение',

  // Luminous header (конвейер ключей: шапка → панели)
  'shell.new': 'Новая',
  'shell.undo': 'Отменить',
  'shell.redo': 'Вернуть',
  'shell.search': 'Поиск и команды',
  'shell.theme.dark': 'Светлая тема',
  'shell.theme.light': 'Тёмная тема',
  'shell.allTools': 'Все',
  'shell.saved': 'Сохранено',
  'shell.saving': 'Сохраняю…',
  'shell.locale.switch': 'Switch language',
  'shell.locale.next': 'Switch to English',

  // Remarks flyout
  'remarks.title': 'Замечания',
  'remarks.filter.open': 'Открытые',
  'remarks.filter.all': 'Все',
  'remarks.filter.resolved': 'Решённые',
  'remarks.onlySelected': 'Только для выделенного',
  'remarks.add.title': 'Добавить замечание',
  'remarks.add.placeholder': 'Текст замечания…',
  'remarks.add.button': 'Добавить',
  'remarks.reply.placeholder': 'Ответ по существу…',
  'remarks.reply.send': 'Отправить',
  'remarks.bulk.selected': 'Выбрано',
  'remarks.bulk.resolve': 'Решить',
  'remarks.bulk.reopen': 'Открыть',
  'remarks.bulk.delete': 'Удалить',
  'remarks.bulk.clear': 'Снять выбор',
  'remarks.selectAll': 'Все в списке',

  // Cutlist / offcuts (A15)
  'cutlist.offcuts.title': 'Остатки',
  'cutlist.offcuts.usable': 'годных',
  'cutlist.offcuts.losses': 'мелкая обрезь',
  'cutlist.offcuts.sheets': 'листов',
  'cutlist.offcuts.threshold': 'годность от',
  'cutlist.offcuts.empty': 'Годных остатков нет — вся обрезь мельче порога годности.',

  // Toasts (export/import)
  'toast.export.success': 'Экспортирован .holzcom',
  'toast.import.success': 'Импортировано',
  'toast.export.failed': 'Экспорт не удался',
  'toast.import.failed': 'Импорт не удался',
  'toast.modelRequired': 'Сначала выберите модель',

  // Mode tabs
  'mode.scene': 'Сцена',
  'mode.analysis': 'Анализ',
  'mode.estimate': 'Смета',
  'mode.drawings': 'Чертежи',

  // Workspaces
  'workspace.scene': 'Сцена',
  'workspace.tech': 'Технолог',
  'workspace.orders': 'Заказы',

  // Common buttons
  'btn.add': 'Добавить',
  'btn.cancel': 'Отмена',
  'btn.save': 'Сохранить',
  'btn.delete': 'Удалить',
  'btn.apply': 'Применить',
  'btn.clear': 'Очистить',
  'btn.close': 'Закрыть',
  'btn.next': 'Дальше',
  'btn.back': 'Назад',

  // Errors / status
  'error.network': 'Ошибка сети',
  'error.conflict': 'Конфликт версий — обновите сцену вручную.',
  'status.loading': 'Загрузка…',
  'status.empty': 'Пусто',

  // (D20) Status bar + global chrome
  'status.gotov': 'ГОТОВ',
  'status.waiting': 'ОЖИДАНИЕ',
  'status.objects': 'объектов',
  'status.rowsBom': 'строк BOM',
  'status.size': 'Габариты',
  'status.units': 'Ед.',
  'status.selected': 'Выбрано',
  'status.undo': 'Отменить',
  'status.redo': 'Вернуть',

  // (D20) Annotations (G1 / D7)
  'ann.title': 'Аннотации',
  'ann.newPlaceholder': 'Новый комментарий…',
  'ann.add': 'Добавить',
  'ann.reply': 'Ответить',
  'ann.status.open': 'открыт',
  'ann.status.resolved': 'решён',
  'ann.status.wontfix': 'не решать',
  'ann.bulk.resolveAll': 'Закрыть все',
  'ann.bulk.assignDesigner': 'Назначить дизайнеру',
  'ann.empty': 'Аннотаций нет',

  // (D20) Compositions
  'comp.create': 'Создать композицию',
  'comp.dissolve': 'Распустить',
  'comp.rename': 'Переименовать',
  'comp.resize': 'Размеры',
  'comp.moveToRoom': 'Перенести в комнату',
  'comp.autoGroup': 'Автогруппа по комнате',

  // (D20) Library
  'lib.title': 'Библиотека модулей',
  'lib.search': 'Поиск…',
  'lib.favorites': 'Избранное',
  'lib.recent': 'Недавние',
  'lib.add': '+ Добавить',
  'lib.dragHint': 'Перетащите в комнату',

  // (D20) Material editor
  'mat.facadeSwap': 'Сменить фасад',
  'mat.corpusSwap': 'Сменить корпус',
  'mat.scope.entity': 'Этой детали',
  'mat.scope.module': 'Модулю',
  'mat.scope.modules': 'Модулям',
  'mat.scope.scene': 'Всей сцене',
  'mat.custom': 'Кастомный материал',
  'mat.preset.editPrice': 'Изменить цену',

  // (D20) Properties / Room inspector
  'prop.room.wallMaterial': 'Стены',
  'prop.room.floorMaterial': 'Пол',
  'prop.room.ceilingMaterial': 'Потолок',
  'prop.room.skirt': 'Плинтус',
  'prop.size.width': 'Ширина',
  'prop.size.depth': 'Глубина',
  'prop.size.height': 'Высота',

  // (D20) Analysis
  'analysis.title': 'Анализ',
  'analysis.validate': 'Проверить',
  'analysis.autofix': 'Открыть анализ',
  'analysis.dryRun': 'Dry-run',
  'analysis.report.pass': 'Проверки пройдены',
  'analysis.report.fail': 'Есть нарушения',

  // (D20) Drawings
  'drawings.title': 'Чертежи',
  'drawings.exportDxf': 'Экспорт DXF',
  'drawings.exportPdf': 'Экспорт PDF',

  // (D20) Common dialogs
  'dialog.confirmTitle': 'Подтвердите действие',
  'dialog.confirmYes': 'Да',
  'dialog.confirmNo': 'Нет',
  'dialog.unsavedTitle': 'Несохранённые изменения',
  'dialog.unsavedBody': 'Изменения будут потеряны. Продолжить?',

  // (D20) Language switcher
  'lang.label': 'Язык',
  'lang.ru': 'Русский',
  'lang.en': 'English',
};

const en: Dict = {
  // Luminous header
  'shell.new': 'New',
  'shell.undo': 'Undo',
  'shell.redo': 'Redo',
  'shell.search': 'Search & commands',
  'shell.theme.dark': 'Light theme',
  'shell.theme.light': 'Dark theme',
  'shell.allTools': 'All',
  'shell.saved': 'Saved',
  'shell.saving': 'Saving…',
  'shell.locale.switch': 'Switch language',
  'shell.locale.next': 'Переключить на русский',

  // Remarks flyout
  'remarks.title': 'Remarks',
  'remarks.filter.open': 'Open',
  'remarks.filter.all': 'All',
  'remarks.filter.resolved': 'Resolved',
  'remarks.onlySelected': 'Only for selected',
  'remarks.add.title': 'Add remark',
  'remarks.add.placeholder': 'Remark text…',
  'remarks.add.button': 'Add',
  'remarks.reply.placeholder': 'Reply…',
  'remarks.reply.send': 'Send',
  'remarks.bulk.selected': 'Selected',
  'remarks.bulk.resolve': 'Resolve',
  'remarks.bulk.reopen': 'Reopen',
  'remarks.bulk.delete': 'Delete',
  'remarks.bulk.clear': 'Clear selection',
  'remarks.selectAll': 'All listed',

  // Cutlist / offcuts (A15)
  'cutlist.offcuts.title': 'Offcuts',
  'cutlist.offcuts.usable': 'usable',
  'cutlist.offcuts.losses': 'small waste',
  'cutlist.offcuts.sheets': 'sheets',
  'cutlist.offcuts.threshold': 'usable from',
  'cutlist.offcuts.empty': 'No usable offcuts — all waste is below the threshold.',

  // Tree
  'tree.search.placeholder': 'Find…',
  'tree.search.title': 'Tree search — modules, compositions, rooms. Cmd/Ctrl+F focuses.',
  'tree.wall_tier.label': 'Wall cab. bottom, mm:',
  'tree.wall_tier.title': 'Height above floor where wall (upper) cabinets land when you drop a wall module into a room. Default 1400 mm.',
  'tree.mode.byRoom': 'By room',
  'tree.mode.byType': 'By type',
  'tree.section.rooms': 'Rooms',
  'tree.section.compositions': 'Compositions',
  'tree.section.apartment': 'Apartment',
  'tree.section.furniture': 'Furniture',
  'tree.section.parts': 'Parts',
  'tree.section.hardware': 'Hardware',

  // Tour
  'tour.next': 'Next →',
  'tour.skip': 'Skip',
  'tour.done': 'Done',

  // Estimate
  'estimate.row.editTitle': 'Click: edit ₽',
  'estimate.row.overriddenTitle': 'Price overridden · click to change',
  'estimate.row.clearTitle': 'Clear override',
  'estimate.title': 'Estimate',
  'estimate.total': 'Total',
  'estimate.materials': 'Materials',
  'estimate.hardware': 'Hardware',
  'estimate.operations': 'Operations',
  'estimate.viewDetailed': 'Detailed',
  'estimate.viewSummary': 'Summary',

  // TopBar
  'topbar.export': 'Export project (.holzcom)',
  'topbar.import': 'Import .holzcom',
  'topbar.commands': 'Commands (⌘K)',
  'topbar.theme.dark': 'Dark theme',
  'topbar.theme.light': 'Light theme',
  'topbar.tour.show': 'Show tour',
  'topbar.tour.hide': 'Hide tour',

  // Toasts
  'toast.export.success': 'Exported .holzcom',
  'toast.import.success': 'Imported',
  'toast.export.failed': 'Export failed',
  'toast.import.failed': 'Import failed',
  'toast.modelRequired': 'Select a model first',

  // Mode tabs
  'mode.scene': 'Scene',
  'mode.analysis': 'Analysis',
  'mode.estimate': 'Estimate',
  'mode.drawings': 'Drawings',

  // Workspaces
  'workspace.scene': 'Scene',
  'workspace.tech': 'Technologist',
  'workspace.orders': 'Orders',

  // Common buttons
  'btn.add': 'Add',
  'btn.cancel': 'Cancel',
  'btn.save': 'Save',
  'btn.delete': 'Delete',
  'btn.apply': 'Apply',
  'btn.clear': 'Clear',
  'btn.close': 'Close',
  'btn.next': 'Next',
  'btn.back': 'Back',

  // Errors / status
  'error.network': 'Network error',
  'error.conflict': 'Version conflict — refresh the scene.',
  'status.loading': 'Loading…',
  'status.empty': 'Empty',

  // (D20) Status bar + global chrome
  'status.gotov': 'READY',
  'status.waiting': 'WAITING',
  'status.objects': 'objects',
  'status.rowsBom': 'BOM rows',
  'status.size': 'Size',
  'status.units': 'Units',
  'status.selected': 'Selected',
  'status.undo': 'Undo',
  'status.redo': 'Redo',

  // (D20) Annotations
  'ann.title': 'Annotations',
  'ann.newPlaceholder': 'New comment…',
  'ann.add': 'Add',
  'ann.reply': 'Reply',
  'ann.status.open': 'open',
  'ann.status.resolved': 'resolved',
  'ann.status.wontfix': 'won’t fix',
  'ann.bulk.resolveAll': 'Resolve all',
  'ann.bulk.assignDesigner': 'Assign to designer',
  'ann.empty': 'No annotations',

  // (D20) Compositions
  'comp.create': 'Create composition',
  'comp.dissolve': 'Dissolve',
  'comp.rename': 'Rename',
  'comp.resize': 'Resize',
  'comp.moveToRoom': 'Move to room',
  'comp.autoGroup': 'Auto-group by room',

  // (D20) Library
  'lib.title': 'Module library',
  'lib.search': 'Search…',
  'lib.favorites': 'Favorites',
  'lib.recent': 'Recent',
  'lib.add': '+ Add',
  'lib.dragHint': 'Drop into a room',

  // (D20) Material editor
  'mat.facadeSwap': 'Swap facade',
  'mat.corpusSwap': 'Swap carcass',
  'mat.scope.entity': 'This part',
  'mat.scope.module': 'Module',
  'mat.scope.modules': 'Modules',
  'mat.scope.scene': 'Whole scene',
  'mat.custom': 'Custom material',
  'mat.preset.editPrice': 'Edit price',

  // (D20) Properties / Room inspector
  'prop.room.wallMaterial': 'Walls',
  'prop.room.floorMaterial': 'Floor',
  'prop.room.ceilingMaterial': 'Ceiling',
  'prop.room.skirt': 'Skirting',
  'prop.size.width': 'Width',
  'prop.size.depth': 'Depth',
  'prop.size.height': 'Height',

  // (D20) Analysis
  'analysis.title': 'Analysis',
  'analysis.validate': 'Validate',
  'analysis.autofix': 'Open analysis',
  'analysis.dryRun': 'Dry-run',
  'analysis.report.pass': 'Checks passed',
  'analysis.report.fail': 'Violations found',

  // (D20) Drawings
  'drawings.title': 'Drawings',
  'drawings.exportDxf': 'Export DXF',
  'drawings.exportPdf': 'Export PDF',

  // (D20) Common dialogs
  'dialog.confirmTitle': 'Confirm action',
  'dialog.confirmYes': 'Yes',
  'dialog.confirmNo': 'No',
  'dialog.unsavedTitle': 'Unsaved changes',
  'dialog.unsavedBody': 'Changes will be lost. Continue?',

  // (D20) Language switcher
  'lang.label': 'Language',
  'lang.ru': 'Russian',
  'lang.en': 'English',
};

export const LOCALES: Record<Locale, Dict> = { ru, en };
